import { ErrorMessage } from "styles/Global.styled"

export const renderError = (message: string) => {
    return <ErrorMessage>{message}</ErrorMessage>
}
